import Button from '../ui/Button';
import Divider from '../ui/Divider';
import { useLanguage } from '../../contexts/LanguageContext';

export default function ParticipantCard({ participant, onVote, disabled = false, blurImage = false }) {
  const { t } = useLanguage();
  const { name, age, image, description, votes } = participant;

  return (
    <div className="flex flex-col gap-0 w-[422px] min-w-[422px] anim-fade-up">
      <div className="relative rounded-t-2xl overflow-hidden ring-1 ring-white/40 shadow-[0_12px_28px_rgba(15,23,42,0.12)]">
        <img
          src={image}
          alt={t('participant.photoAlt', { name })}
          className={`w-[422px] h-[615px] object-cover ${blurImage ? 'blur-md scale-[1.03]' : ''}`}
        />

        {blurImage && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-sm px-6">
            <div className="text-center">
              <p className="text-slate-900 font-bold text-lg">{t('participant.photoHidden')}</p>
              <p className="mt-1 text-slate-700 text-sm">
                {t('locked.hint')}
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="border border-white/50 rounded-b-2xl bg-white/80 backdrop-blur shadow-[0_12px_30px_rgba(2,132,199,0.15)]">
        <p className="text-lg font-semibold px-4 pt-4">
          {name}, <span className="font-normal">{age}</span>
        </p>

        <Divider className="my-3" />

        <p className="text-sm px-4 pb-3 text-slate-600 leading-5">{description}</p>

        <p className="font-semibold text-sm px-4 pb-3 text-slate-800">
          {t('participant.votesLabel')} <span className="font-normal">{votes}</span>
        </p>

        <div className="pb-4 px-4">
          <Button 
            size="lg" 
            className="w-full" 
            onClick={() => onVote?.(participant)}
            disabled={disabled}
          >
            {disabled ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-slate-300 border-t-sky-500 rounded-full animate-spin" />
                {t('participant.voting')}
              </span>
            ) : (
              t('vote.voteButton')
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
